import { CALL_API } from '../../../middleware/api';
import * as ActionTypes from '../bettingHistory';
function fetchBettingHistory(data, filterType) {
    var _a;
    var startDate = data.startDate, finishDate = data.finishDate, languageId = data.languageId;
    var endpoint = filterType === 'active' ?
        "/api/gambler/reporting/stakes/active?languageId=".concat(languageId === 13 ? 5 : languageId) :
        "/api/gambler/reporting/stakes/all?startdate=".concat(startDate, "&enddate=").concat(finishDate, "&languageId=").concat(languageId === 13 ? 5 : languageId);
    return _a = {
            type: ActionTypes.FETCH_BETTING_HISTORY
        },
        _a[CALL_API] = {
            endpoint: endpoint,
            method: 'get',
            types: [
                ActionTypes.SUCCESS_FETCH_BETTING_HISTORY,
                ActionTypes.FAILURE_FETCH_BETTING_HISTORY
            ],
            credentials: true,
            data: data
        },
        _a;
}
export function getBettingHistory(data, filterType) {
    return function (dispatch, getState) {
        data['languageId'] = getState().application.get('languageId');
        return dispatch(fetchBettingHistory(data, filterType));
    };
}
export function clearBetHistory() {
    return { type: ActionTypes.CLEAR_BET_HISTORY };
}



// WEBPACK FOOTER //
// ./src/actions/betting-history/creators/bettingHistory.js